// Numbered chapter pills right under the guide hero — the long page's
// table of contents, rendered only for sections that actually exist.
// The numbers echo in each section's eyebrow so chips and chapters read
// as one system.
export default function ChapterChips({ chapters }) {
  if (!chapters || chapters.length < 2) return null;

  return (
    <nav
      aria-label="On this page"
      className="tw-mx-auto tw-flex tw-max-w-4xl tw-flex-wrap tw-items-center tw-justify-center tw-gap-2.5 tw-px-4 tw-pt-9"
    >
      {chapters.map((chapter, i) => (
        <a
          key={chapter.id}
          href={`#${chapter.id}`}
          className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F] tw-bg-white dark:tw-bg-[#15231E] tw-px-4 tw-py-2 tw-font-mono tw-text-[10.5px] tw-font-semibold tw-uppercase tw-tracking-[0.16em] tw-text-[#00695C] dark:tw-text-primary-300 tw-no-underline tw-shadow-[0_10px_24px_-18px_rgba(29,45,40,0.5)] tw-transition-colors hover:tw-border-primary-600/60 hover:tw-bg-primary-600/[0.05] dark:hover:tw-border-primary-300/50"
        >
          <span
            aria-hidden="true"
            className="tw-text-[#C9C0AA] dark:tw-text-[#3A4D44]"
          >
            {String(i + 1).padStart(2, '0')}
          </span>
          {chapter.label}
        </a>
      ))}
    </nav>
  );
}
